import RestaurantStore from "./store";

export const {
  useStoreActions,
  useStoreDispatch,
  useStoreState,
  useStoreRehydrated,
  useStore,
} = RestaurantStore;
